import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
const baseApiUrl = '';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};
@Injectable({
  providedIn: 'root'
})
export class TatConsiderationService {
  constructor( private http: HttpClient) {
    
  }
 

  public getCommonListTatConsideration(): Observable<any> {
    const get_url = baseApiUrl + 'commonList/TATConsideration';
    return this.http.get<any>(get_url);
  }

}
